import React, { useContext, useEffect } from 'react';
import { ProductContext } from '../../ProductContext';
import { StoreLocatorSidebar } from './StoreLocatorSidebar';
import { IColorwayProductData, IVariant, TUserSelections } from '../../types/PDP';

export const StoreLocatorSidebarPDPWrapper = ({
  product,
  selectedVariant,
  userSelections,
  isAvailableOnline,
}: {
  product?: IColorwayProductData;
  selectedVariant?: IVariant;
  userSelections: TUserSelections;
  isAvailableOnline?: boolean;
}) => {
  const { setSidebarPdpData } = useContext(ProductContext);

  useEffect(() => {
    if (product && selectedVariant && userSelections.length > 0) {
      setSidebarPdpData({
        product,
        userSelectedSize: userSelections[0].Size,
        selectedVariant,
        isAvailableOnline,
      });
    }
  }, [product, selectedVariant, userSelections, isAvailableOnline, setSidebarPdpData]);

  return <StoreLocatorSidebar />;
};
